module.exports = __webpack_public_path__ + "img/centre-services-scolaire-patriotes.c20ae87e.webp";